import { useState, useEffect } from 'react';

const useServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await fetch('/api/services');
        if (!res.ok) throw new Error('Failed to fetch services');
        const data = await res.json();
        
        const mapped = data
          .filter(service => service.is_active)
          .map(service => ({
            id: service.id,
            name: service.name,
            description: service.description || '',
            image: service.image_url || '',
            buttonText: service.button_text || 'Learn More',
            category: service.category_slug || service.category_name?.toLowerCase() || 'residential',
            slug: service.name?.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and') || ''
          }));
        
        setServices(mapped);
      } catch (err) {
        console.error('Failed to fetch services:', err);
        setError(err.message);
        setServices([]);
      }
      setLoading(false);
    };

    fetchServices();
  }, []);

  return { services, loading, error };
};

export default useServices;
